// Import model
import { DataviewLaminatesCatalogItemResponse } from '../models/DataviewLaminatesCatalogItemResponse';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { DataView } from '../models/DataView';
import { FilterLaminatesCatalogItemRequest } from '../models/FilterLaminatesCatalogItemRequest';
import { LaminatesCatalogItem } from '../models/LaminatesCatalogItem';

// Import dependency serializers (for complex types)
import { DataViewSerializer } from './DataViewSerializer';
import { FilterLaminatesCatalogItemRequestSerializer } from './FilterLaminatesCatalogItemRequestSerializer';
import { LaminatesCatalogItemSerializer } from './LaminatesCatalogItemSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for DataviewLaminatesCatalogItemResponse - handles JSON serialization and deserialization with type validation
 */
export class DataviewLaminatesCatalogItemResponseSerializer {
  /**
   * Deserializes a JSON string into a DataviewLaminatesCatalogItemResponse instance
   */
  static deserialize(json: string): DataviewLaminatesCatalogItemResponse {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a DataviewLaminatesCatalogItemResponse instance
   */
  static fromObject(obj: any): DataviewLaminatesCatalogItemResponse {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to DataviewLaminatesCatalogItemResponse');
    }


    const instance: DataviewLaminatesCatalogItemResponse = {
      result: obj['Result'] ? (obj['Result'] as any[]).map((item: any) =>
        LaminatesCatalogItemSerializer.fromObject(item)
      ) : [] as any,
      request: obj['Request'] ? FilterLaminatesCatalogItemRequestSerializer.fromObject(obj['Request']) : undefined as any,
      dataView: obj['DataView'] ? DataViewSerializer.fromObject(obj['DataView']) : undefined as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of DataviewLaminatesCatalogItemResponse instances
   */
  static deserializeArray(json: string): DataviewLaminatesCatalogItemResponse[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a DataviewLaminatesCatalogItemResponse instance to a JSON string
   */
  static serialize(instance: DataviewLaminatesCatalogItemResponse): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a DataviewLaminatesCatalogItemResponse instance to a plain object
   */
  static toObject(instance: DataviewLaminatesCatalogItemResponse): any {
    return {
      'Result': instance.result?.map((item: any) =>
        LaminatesCatalogItemSerializer.toObject(item)
      ),
      'Request': instance.request ? FilterLaminatesCatalogItemRequestSerializer.toObject(instance.request) : undefined,
      'DataView': instance.dataView ? DataViewSerializer.toObject(instance.dataView) : undefined,
    };
  }

  /**
   * Serializes an array of DataviewLaminatesCatalogItemResponse instances to a JSON string
   */
  static serializeArray(instances: DataviewLaminatesCatalogItemResponse[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
